export default {
  Label_Common: {
    Dai_ChuShiHua: 'Waiting init',
    ZhengZai_ChuShiHua: 'Initializing',
    YiChang: 'Abnormal',
    ZhengChang_YingYe: 'Open',
    TingZhi_YingYe: 'Closed',
  },
}
